<div class="portal-page">

	<!-- Top bar -->
	<portal-header mode="section" [projectId]="projectId" current="documents" [sections]="sections"></portal-header>

	<portal-loader *ngIf="loading"></portal-loader>
	<div class="sec-state portal-error" *ngIf="error">{{ error }}</div>

	<div class="section-scroll" *ngIf="!loading && !error">
		<div class="doc-empty" *ngIf="!documents.length">
			<i class="wq wq-copy"></i>
			<div class="doc-empty-title">No documents yet</div>
			<div class="doc-empty-sub">Documents shared with you will appear here.</div>
		</div>

		<div class="doc-table-wrap" *ngIf="documents.length">
			<table class="table doc-table">
				<thead>
					<tr>
						<th class="doc-col-name">Name</th>
						<th class="doc-col-owner">Added by</th>
						<th class="doc-col-date">Date</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let d of documents" (click)="openDocument(d)" class="selectable">
						<td class="doc-col-name">
							<div class="doc-name-cell d-flex align-items-center gap-2">
								<div class="doc-file-icon"><i class="wq wq-link"></i></div>
								<a class="doc-file-name doc-file-link" *ngIf="d.url; else noLink" [href]="d.url" target="_blank" rel="noopener">{{ d.name }}</a>
								<ng-template #noLink><div class="doc-file-name">{{ d.name }}</div></ng-template>
							</div>
						</td>
						<td class="doc-col-owner"><span class="doc-owner">{{ d.owner || '—' }}</span></td>
						<td class="doc-col-date"><span class="doc-date">{{ when(d.datetime) || '—' }}</span></td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>

	<!-- Footer -->
	<portal-project-footer [projectId]="projectId"></portal-project-footer>
</div>
